import safeJSONParse from '../utils/safeJsonParse';

const initAccordion = () => {
  const accordions = document.querySelectorAll('[data-accordion]');

  if (accordions.length === 0) return;

  const CONTENT_PADDING_BOTTOM = 16;
  const headerHeight = document.querySelector('[data-header-group]').offsetHeight;

  accordions.forEach(accordion => {
    const config = accordion.dataset.accordionConfig ? safeJSONParse(accordion.dataset.accordionConfig, false) : {};
    !config ? console.error('Error in Accordion JSON') : null;
    const toggles = accordion.querySelectorAll('[data-accordion-toggle]');

    const onCloseAccordion = toggle => {
      toggle.classList.remove('new-accordion__title--open');
      const toggleContent = toggle.nextElementSibling;
      toggleContent.style.maxHeight = 0;
      toggleContent.style.paddingBottom = 0;
      toggleContent.classList.remove('new-accordion__content--open');
    };

    // Resolve the actual toggle element whether an Event or an Element was passed
    function resolveToggleFromEventish(eventish) {
      if (eventish && eventish.nodeType === 1 && eventish.hasAttribute('data-accordion-toggle')) {
        return eventish;
      }
      if (
        eventish &&
        eventish.currentTarget &&
        eventish.currentTarget.hasAttribute &&
        eventish.currentTarget.hasAttribute('data-accordion-toggle')
      ) {
        return eventish.currentTarget;
      }
      if (eventish && eventish.target && eventish.target.closest) {
        const closestToggle = eventish.target.closest('[data-accordion-toggle]');
        if (closestToggle) return closestToggle;
      }
      return null;
    }

    function openAccordion(evtOrEl, scroll) {
      // Allow Enter key to trigger; ignore other keydowns
      if (evtOrEl && evtOrEl.type === 'keydown' && evtOrEl.key !== 'Enter') return;

      const target = resolveToggleFromEventish(evtOrEl);
      if (!target) return;

      config.closeAllOnOpen ? toggles.forEach(toggle => onCloseAccordion(toggle)) : null;

      const content = target.nextElementSibling;
      const contentHeight = content.scrollHeight;
      target.classList.add('new-accordion__title--open');
      content.style.maxHeight = `${contentHeight + CONTENT_PADDING_BOTTOM}px`;
      content.style.paddingBottom = `${CONTENT_PADDING_BOTTOM}px`;
      content.classList.add('new-accordion__content--open');
      if (scroll) {
        setTimeout(() => {
          const isScrollingUp = document.querySelector('body').classList.contains('scrolling-up') ? true : false;
          const scrollPosition = isScrollingUp ? target.offsetTop - headerHeight : target.offsetTop + headerHeight;

          window.scrollTo({
            top: window.matchMedia('(min-width: 1024px)').matches
              ? isScrollingUp
                ? scrollPosition + 66
                : scrollPosition + 37
              : scrollPosition - 50,
            left: 0,
            behavior: 'smooth'
          });
        }, 500); // delay to allow the previous accordion to close
      }
    }

    function onToggle(evt) {
      // Allow Enter key to trigger; ignore other keydowns
      if (evt.type === 'keydown' && evt.key !== 'Enter') return;
      const target = resolveToggleFromEventish(evt);
      if (!target) return;
      const isOpen = target.classList.contains('new-accordion__title--open');
      if (isOpen) {
        onCloseAccordion(target);
      } else {
        openAccordion(target, false);
      }
    }

    if (config.mobileOnly === true) {
      accordion.classList.add('accordion--mobile-only');
    }

    toggles.forEach((toggle, i) => {
      toggle.addEventListener('click', onToggle);
      toggle.addEventListener('keydown', onToggle);

      if (config.openFirst === true && i === 0) {
        openAccordion(toggle, false);
      }
    });

    const reviewsScrollLinks = accordion.querySelectorAll('[data-reviews-scroll]');
    reviewsScrollLinks.forEach(link => {
      const handleReviewsScroll = (e) => {
        if (e.type === 'keydown' && e.key !== 'Enter') return;
        e.preventDefault();

        const reviewsSection = document.querySelector('#reviews') ||
                              document.querySelector('.jdgm-widget:not(.jdgm-preview-badge)') ||
                              document.querySelector('[data-section-type*="app"]');

        if (reviewsSection) {
          const headerHeight = document.querySelector('[data-header-group]')?.offsetHeight || 0;
          const rect = reviewsSection.getBoundingClientRect();
          const scrollPosition = rect.top + window.scrollY - headerHeight - 20;

          window.scrollTo({
            top: scrollPosition,
            left: 0,
            behavior: 'smooth'
          });
        }
      };

      link.addEventListener('click', handleReviewsScroll, { capture: true });
      link.addEventListener('keydown', handleReviewsScroll);
    });
  });
};

export default initAccordion;
